import CoreLayout from './components/CoreLayout';
import BannerResolutionFix from './BannerResolutionFix';

/* import Forms from './Forms';
import GForms from './GForms';
*/
import Header from './Header';
import Shop from './Shop.js'; 
import CustomizationFields from './CustomizationFields';
import CategoryListing from './CategoryListing';
import SavedCustomizations from './SavedCustomizations';
import CartCustomizations from './CartCustomizations';

let isInitialized = false;
CoreLayout.watchDimensions();

function init() {
  if (isInitialized) { return; }
  isInitialized = true;
  
  Header.init();
  Shop.init();
  BannerResolutionFix.init();
  CategoryListing.init();
  CustomizationFields.init();
  SavedCustomizations.init();
  CartCustomizations.init();
  
  // Note that GForms should be initialized before Forms, at least until we move the
  // select empty-option logic from GForms to generic Forms.
  // GForms.init();
  // Forms.init();
}

document.addEventListener('DOMContentLoaded', init);
document.addEventListener('pageshow', init);

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  init();
}
